"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _reactRedux = require("react-redux");
var _InterestPaymentsTable = _interopRequireDefault(require("../InterestPayments/InterestPaymentsTable/"));
var _interestBearingAccountsSelectors = require("../../../redux/selectors/interestBearingAccountsSelectors");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var mapStateToProps = function mapStateToProps(state) {
  return {
    interestPayments: (0, _interestBearingAccountsSelectors.filteredInterestPaymentsSelector)(state)
  };
};
var _default = exports["default"] = (0, _reactRedux.connect)(mapStateToProps)(_InterestPaymentsTable["default"]);